import { useState } from 'react';
import { uuid } from '../';
export default ({ componentProps = {}, fieldProps, decoratorProps = {}, style, ...extra }, defaultProps) => {
    const [defaultName] = useState(uuid());
    const { name, ...rest } = fieldProps;
    const schema = {
        type: 'object',
        properties: {
            [name || defaultName]: {
                type: 'void',
                ...defaultProps,
                ...rest,
                'x-component-props': {
                    style,
                    ...componentProps['x-component-props'],
                    ...(extra || {}),
                },
                ...decoratorProps,
            },
        },
    };
    return schema;
};
